import { Text } from '@wartek-id/text-v1'

import { assetUrl } from 'utils/url'

type TahapPerencanaanCardProps = {
  orderNumber: number
  title: string
  subtitle: string
  imagePath: string
}

export function TahapPerencanaanCard({
  orderNumber,
  title,
  subtitle,
  imagePath,
}: TahapPerencanaanCardProps) {
  return (
    <div className="flex items-center justify-start gap-4 px-4 py-5 bg-white rounded-lg">
      <div className="h-6 min-w-6 p-1 flex items-center justify-center rounded-full bg-gray-70 flex-shrink-0">
        <Text variant="heading-sm" color="inverse" as="span">
          {orderNumber}
        </Text>
      </div>
      <div className="flex-0 w-16 h-16">
        <img src={assetUrl(imagePath)} alt="" />
      </div>
      <div className="space-y-2">
        <Text variant="heading-sm" className="mb-1">
          {title}
        </Text>
        <Text color="subdued" variant="body-sm">
          {subtitle}
        </Text>
      </div>
    </div>
  )
}
